import React, { FC } from 'react';

const RssIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 11"
    width="11"
    height="11"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="m1.842562,11.024711a1.797105,1.794323 0 1 1 0,-3.587974a1.797105,1.794323 0 0 1 0,3.587974zm-1.797105,-5.382298l0,-1.794323c3.969533,0 7.187746,3.213232 7.187746,7.176621l-1.797105,0a5.390641,5.382298 0 0 0 -5.390641,-5.382298zm0,-3.587974l0,-1.794323c5.954637,0 10.781281,4.819175 10.781281,10.764595l-1.797105,0a8.984177,8.970272 0 0 0 -8.984177,-8.970272z"
      />
    </g>
  </svg>
);

export default RssIcon;
